import {
  TICKET_DETAILS_V2_FETCH_START,
  TICKET_DETAILS_V2_FETCH_SUCCESS,
  TICKET_DETAILS_V2_FETCH_ERROR,
  TICKET_DETAILS_V2_RESET,
} from "../../constants/ActionTypes";

const INIT_STATE = {
  ticket: null,
  addresses: [],
  allocatedPartners: [],
  revisitDescending: null,
  workOrders: null,
  documentsUploaded: null,
  documentRequirements: [],
  notes: [],
  engineers: [],
  locationTypes: [],
  loading: false,
  error: null,
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case TICKET_DETAILS_V2_FETCH_START:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case TICKET_DETAILS_V2_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        error: null,
        ticket:
          action.payload.ticket !== undefined ? action.payload.ticket : state.ticket,
        addresses:
          action.payload.addresses !== undefined
            ? action.payload.addresses
            : state.addresses,
        allocatedPartners:
          action.payload.allocatedPartners !== undefined
            ? action.payload.allocatedPartners
            : state.allocatedPartners,
        revisitDescending:
          action.payload.revisitDescending !== undefined
            ? action.payload.revisitDescending
            : state.revisitDescending,
        workOrders:
          action.payload.workOrders !== undefined
            ? action.payload.workOrders
            : state.workOrders,
        documentsUploaded:
          action.payload.documentsUploaded !== undefined
            ? action.payload.documentsUploaded
            : state.documentsUploaded,
        documentRequirements:
          action.payload.documentRequirements !== undefined
            ? action.payload.documentRequirements
            : state.documentRequirements,
        notes:
          action.payload.notes !== undefined ? action.payload.notes : state.notes,
        engineers:
          action.payload.engineers !== undefined
            ? action.payload.engineers
            : state.engineers,
        locationTypes:
          action.payload.locationTypes !== undefined
            ? action.payload.locationTypes
            : state.locationTypes,
      };
    case TICKET_DETAILS_V2_FETCH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case TICKET_DETAILS_V2_RESET:
      return { ...INIT_STATE };
    default:
      return state;
  }
};
